import { AgencyInvite } from './AgencyInvite'

export const AgencyPage = () => {
  return <AgencyInvite />
}

export default AgencyPage
